/**
 * Simple Sticky Add to Cart
 * Handles scroll visibility and button trigger only
 */

class StickyAddToCart {
  constructor() {
    this.stickyCart = document.getElementById('sticky-add-to-cart');
    this.stickyButton = document.getElementById('sticky-add-to-cart-trigger');
    this.mainProductSection = document.querySelector('[id^="MainProduct-"]');
    this.mainAddToCartButton = document.querySelector('.product form[action*="/cart/add"] button[name="add"],.product form[action*="/cart/add"] button[type="submit"]');
    
    if (!this.stickyCart || !this.stickyButton || !this.mainProductSection || !this.mainAddToCartButton) {
      return;
    }

    this.init();
  }

  init() {
    this.setupScrollListener();
    this.setupButtonClick();
  }

  setupScrollListener() {
    let ticking = false;
    let isVisible = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const productSectionRect = this.mainProductSection.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          
          // Show sticky cart when scrolled past product section
          const shouldShow = productSectionRect.bottom < (windowHeight * 0.8);
          
          // Only update if state actually changes
          if (shouldShow && !isVisible) {
            this.showStickyCart();
            isVisible = true;
          } else if (!shouldShow && isVisible) {
            this.hideStickyCart();
            isVisible = false;
          }
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  showStickyCart() {
    // Remove hidden class first, then add show class
    this.stickyCart.classList.remove('hidden');
    // Force reflow to ensure hidden class is removed before adding show
    this.stickyCart.offsetHeight;
    this.stickyCart.classList.add('show');
  }

  hideStickyCart() {
    // Remove show class first
    this.stickyCart.classList.remove('show');
    // Add hidden class after animation completes
    setTimeout(() => {
      if (!this.stickyCart.classList.contains('show')) {
        this.stickyCart.classList.add('hidden');
      }
    }, 300);
  }

  setupButtonClick() {
    this.stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Prevent multiple clicks
      if (this.stickyButton.classList.contains('loading')) {
        return;
      }
      
      // Start loading animation
      this.showLoadingAnimation();
      
      // Add click animation
      this.stickyButton.classList.add('clicked');
      setTimeout(() => {
        this.stickyButton.classList.remove('clicked');
      }, 200);
      
      // Trigger main add to cart button
      if (this.mainAddToCartButton && !this.mainAddToCartButton.disabled) {
        this.mainAddToCartButton.click();
        console.log('mainAddToCartButton clicked', this.mainAddToCartButton);
        // Listen for the main form's completion to stop our loading
        this.listenForFormCompletion();
      }
    });
  }

  showLoadingAnimation() {
    this.stickyButton.classList.add('loading');
    this.stickyButton.setAttribute('aria-disabled', 'true');
    
    const spinner = this.stickyButton.querySelector('.loading-overlay__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }
  }

  hideLoadingAnimation() {
    this.stickyButton.classList.remove('loading');
    this.stickyButton.removeAttribute('aria-disabled');
    
    const spinner = this.stickyButton.querySelector('.loading-overlay__spinner');
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }

  listenForFormCompletion() {
    const mainForm = this.mainAddToCartButton.closest('form');
    
    if (mainForm) {
      // Create a MutationObserver to watch for class changes on the main button
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (!target.classList.contains('loading')) {
              // Main button finished loading, stop our loading too
              this.hideLoadingAnimation();
              observer.disconnect();
            }
          }
        });
      });
      
      // Start observing the main add to cart button
      observer.observe(this.mainAddToCartButton, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      // Fallback timeout in case something goes wrong
      setTimeout(() => {
        this.hideLoadingAnimation();
        observer.disconnect();
      }, 10000); // 10 second timeout
    }
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new StickyAddToCart();
});